class TagSwatches extends HTMLElement {
    constructor() {
      super();
    }
  
    connectedCallback() {
      this._selectors = {
          relatedColors: '[js-related-colors]'
      };
      this._initRelatedColors();
      window.addEventListener("popstate", this._popStateRender);
    }

    disconnectedCallback() {
      window.removeEventListener("popstate", this._popStateRender);
    }

    async _initRelatedColors() {
      this.relatedColorsContainer = this.querySelectorAll(this._selectors.relatedColors);

      if (this.relatedColorsContainer.length < 1) {
          return;
      }

      const relatedColorsTag = this.relatedColorsContainer[0].getAttribute('data-tag');

      if (relatedColorsTag == '' || relatedColorsTag == null) {
          return;
      }

      const currentProductHandle = this.relatedColorsContainer[0].getAttribute('data-handle');
      const showColorChip = this.relatedColorsContainer[0].getAttribute('data-show-color-chip') === 'true'; 
      const targetURL = `/collections/all/${relatedColorsTag}/?view=json`;

      const relatedColorsJSON = await this._getRelatedColorJSON(targetURL);
      let relatedColorsMarkup = '';

      if (relatedColorsJSON.length <= 1) {
          return;
      }

      relatedColorsJSON.forEach((product) => {
          let productURL = product.url
          let language;
          const windowURL = window.location.href;
          let firstString = windowURL.split('/');
          if (firstString[3].includes('-')){
            language = '/' + firstString[3]
            productURL = language + productURL
          }

          let colorIndicator;
          if (showColorChip) {
            colorIndicator = `<div class="product-related-color__chip" style="background-color: ${product.colorHex};"></div>`
          } else {
            colorIndicator = `<img class="product-related-color__img h-full w-auto mx-auto" sizes="90px" src="${product.swatch}" alt="${product.colorTitle}" role="presentation">`;
          }
          
          if (product.handle == currentProductHandle) {
            relatedColorsMarkup = `${relatedColorsMarkup}<div class="product-related-colors__color product-related-colors__color--current" aria-current="true" aria-label="${product.colorTitle}" js-related-color-swatch>${colorIndicator}</div>`
          }else{
            relatedColorsMarkup = `${relatedColorsMarkup}<a href="${productURL}" class="product-related-colors__color product-related-colors__color--related" aria-label="${product.title} in ${product.colorTitle} color" data-color="${product.colorTitle}" js-related-color-swatch js-color-swatch-link>${colorIndicator}</a>`
          }
      })

      this.relatedColorsContainer.forEach(container => {
      container.innerHTML = relatedColorsMarkup;
      container.classList.remove('hidden');
      })

      this._handleColorHover()
      this._colorSwatchLinksOnClick();
    }

    _handleColorHover(){
        const currentColor = this.relatedColorsContainer[0].querySelector(".product-related-colors__color--current");
        const currentColorText = document.querySelector(".product__variant-color");
        const colors = this.relatedColorsContainer[0].querySelectorAll(".product-related-colors__color--related")

        if (!currentColor || !currentColorText) {
          return;
        }

        colors.forEach((color) => {
          color.addEventListener("mouseenter", function (event) {
            const target = event.currentTarget;
            if (
              target &&
              target.classList.contains("product-related-colors__color--related")
            ) {
              currentColorText.innerText = target.getAttribute("data-color");
            }
          });
        });
    
        colors.forEach((color) => {
            color.addEventListener("mouseleave", function (event) {
            const target = event.currentTarget;
            if (target.classList.contains("product-related-colors__color--related")) {
              currentColorText.innerText = currentColor.getAttribute("aria-label");
            }
          });
        });
    }

    _getRelatedColorJSON(url) {
    return fetch(url)
        .then(response => response.text())
        .then((text) => {
        const html = text;
        const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
        const JSONcontainer = parsedHTML.querySelector('[js-products-json]');
        const parsedJSON = JSON.parse(JSONcontainer.innerHTML);
        return parsedJSON;
        })
    }

    _colorSwatchLinksOnClick = () => {
      const swatchLinks = this.querySelectorAll('[js-color-swatch-link]');
      swatchLinks.forEach((link) => {
        link.addEventListener('click', (evt) => {
        evt.preventDefault();

        let url = evt.currentTarget.href;
        if (this.dataset.collection) {
            const indexPosition = url.indexOf('products/')
            const withinColleciton = `collections/${this.dataset.collection}/`;
            url = url.slice(0, indexPosition) + withinColleciton + url.slice(indexPosition);
        }
        this._renderSwatchLink(url, true);
        })
    })
    }

    _renderSwatchLink = (url, pushState) => {
        fetch(url)
        .then((response) => response.text())
        .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');

            const oldMain = document.querySelector('.product-information ');
            const newMain = html.querySelector('.product-information ');
            oldMain.innerHTML = newMain.innerHTML;

            // Sync "Complete the Look" (product-recommendations) with the new colorway.
            // The recommendations element lives outside .product-information, so update
            // its product id and let its MutationObserver re-fetch the right products.
            const newRecs = html.querySelectorAll('product-recommendations');
            newRecs.forEach((newRec) => {
              const cur = document.querySelector(`product-recommendations[id="${newRec.id}"]`);
              if (cur && newRec.dataset.productId) {
                cur.classList.remove('hidden');
                cur.dataset.recommendationsPerformed = 'false';
                cur.dataset.productId = newRec.dataset.productId;
              }
            });
            
            if (pushState === true) {
              window.history.pushState({}, "", url);
            }

            // The innerHTML swap above replaced this element with a fresh
            // instance whose own connectedCallback re-initializes everything;
            // this superseded instance must not re-register.
        })
        .catch((e) => {
            console.error(e);
        });
    }

    _popStateRender = () => {
      this._renderSwatchLink(document.location, false)
    }
  
  }
  
  if (!customElements.get('s-tag-swatches')) {
    customElements.define('s-tag-swatches', TagSwatches);
  }